import { Outlet } from "react-router-dom"

const Screen = () => {
    return <Outlet />
}

export default Screen